export var IconPositionEnum;
(function (IconPositionEnum) {
    IconPositionEnum["unset"] = "unset";
    IconPositionEnum["Left"] = "Left";
    IconPositionEnum["Right"] = "Right";
})(IconPositionEnum || (IconPositionEnum = {}));
//# sourceMappingURL=buttonIconPositionEnum.js.map